import { Component } from "@angular/core";
import { UcdpSumissionDataModel } from "../../../../model/ucdp.model";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: 'cv-ucdp-submission-error-dialog',
	templateUrl: 'ucdp-submission-error-dialog.component.html'
})
export class UcdpSubmissionErrorDialogComponent {
	item!: UcdpSumissionDataModel;

	constructor(
		public dialogRef: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig
	) {
		this.item = this.dialogConfig.data.item;
	}

	close() {
		this.dialogRef.close();
	}
}
